var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("DetailsTarif", { ref: "detailsTarif" }),
      _c(
        "b-modal",
        {
          attrs: {
            size: "xl",
            title: "Gestion des favoris : " + _vm.ingredientFavori.nom,
            "hide-footer": ""
          },
          model: {
            value: _vm.afficherFavoris,
            callback: function($$v) {
              _vm.afficherFavoris = $$v
            },
            expression: "afficherFavoris"
          }
        },
        [
          _c("template", { slot: "default" }, [
            _vm.ingredientFavori.articles
              ? _c(
                  "div",
                  { staticClass: "container-fluid" },
                  [
                    _c("ArticlesParProduit", {
                      attrs: {
                        articles: _vm.ingredientFavori.articles,
                        favoris: _vm.ingredientFavori.favoris
                      },
                      on: {
                        "toggle-favori": function($event) {
                          return _vm.onToggleFavoriModal($event)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        2
      ),
      _c("Mercuriales", {
        ref: "mercuriales",
        attrs: { startFilters: _vm.filters, lectureSeule: false },
        on: {
          "clic-produit": _vm.openModalFavoris,
          "clic-tarif": _vm.openModalTarif,
          "filter-changed": _vm.setUrl
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }